import * as actions from './actions';
import mutations from './mutations';

const state = {
  certificates: [],
};

export const certificates = {
  namespaced: true,
  state,
  actions,
  mutations,
};
